import { Component, Input, EventEmitter, Output, OnInit, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { Community } from '../../shared/datamodel';
import { WindowrefService } from 'src/app/services/windowref/windowref.service';
import { FirestoreService } from 'src/app/services/firestore/firestore.service';
import { faAngleDoubleLeft, faAngleDoubleRight, faArrowAltCircleLeft, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
import { environment } from 'src/environments/environment';

import * as moment from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import { NucampanalyticsService } from 'src/app/services/nucampanalytics/nucampanalytics.service';
import { UsersService } from 'src/app/services/users/users.service';
import { IonSlides, IonicModule } from '@ionic/angular';
import { debounceTime, firstValueFrom, lastValueFrom } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BootcampComponent } from '../bootcamp/bootcamp.component';
import { NgIf, NgFor } from '@angular/common';
moment.extend(utc);

/**
 * Generated class for the BootcampsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    styleUrls: ['./bootcamps.scss'],
    selector: 'bootcamps',
    templateUrl: 'bootcamps.html',
    standalone: true,
    imports: [NgIf, IonicModule, NgFor, BootcampComponent, FontAwesomeModule]
})
export class BootcampsComponent implements OnChanges {
  @Input() community: Community;
  @Input() showSchedule: boolean;
  @Input() comingsoon: boolean;
  @Output() selBootcampEvent: EventEmitter<any> = new EventEmitter();
  @Output() cancelTimer: EventEmitter<any> = new EventEmitter();
  @ViewChild('bootcampSlider') bootcampSlider: IonSlides

  faArrowAltCircleLeft = faArrowAltCircleLeft;
  faArrowAltCircleRight = faArrowAltCircleRight;
  faAngleDoubleRight = faAngleDoubleRight;
  faAngleDoubleLeft = faAngleDoubleLeft;
  environment = environment;
  showSpinner = false;
  loadingArtifacts;
  bootcamps;
  currentCommunity;
  bootcampSliderOptions = {
    pagination: {el: '.swiper-pagination', type: 'bullets', clickable: true},
    navigation: {nextEl: '.nucamp-swiper-button-next',prevEl: '.nucamp-swiper-button-prev'},
    pager: true,
    slidesPerView: 3,
    breakpoints: {
      200: {slidesPerView: 1.1},
      720: {slidesPerView: 2.2},
      1100: {slidesPerView: 3.2},
    }
  }
  constructor(
    private db: FirestoreService,
    private userdb: UsersService,
    public windowRef: WindowrefService,
    private nucampAnalytics: NucampanalyticsService
    ) { }

    ionViewWillLeave() {
      // console.log("destroying communitycard");
    }
 
  
    ngOnChanges(changes: SimpleChanges) {
      this.loadingArtifacts = this.showSchedule ? [1,2,3,4] : [1,2];
      if (
          !this.currentCommunity ||
          (changes.community && changes.community.currentValue && this.currentCommunity && this.currentCommunity.id !== changes.community.currentValue.id)
        ) {
            // console.log("Bootcamp Community Change", changes);
            if (changes?.community?.currentValue) this.currentCommunity = changes.community.currentValue;
            // console.log("Current Community", this.currentCommunity);
            return this.loadBootcamps2();
          }
    }

    emitCancelTimer() {
      this.cancelTimer.emit(null);
    }

    async swipePrevBootcamps() {
      await Promise.all([
        this.bootcampSlider.slidePrev(),
        this.nucampAnalytics.event("Page", "Slider", `Bootcamps`),
        this.nucampAnalytics.browseWebsite(this.userdb.loggedUser)
      ]);
    }

    async swipeNextBootcamps() {
      await Promise.all([
        this.bootcampSlider.slideNext(),
        this.nucampAnalytics.event("Page", "Slider", `Bootcamps`),
        this.nucampAnalytics.browseWebsite(this.userdb.loggedUser)
      ]);
    }

    async ionSlideDidChange() {
      await Promise.all([
        this.nucampAnalytics.event("Page", "Slider", `Bootcamps`),
        this.nucampAnalytics.browseWebsite(this.userdb.loggedUser)
      ]);
    }

    loadBootcamps2() {
      this.showSpinner = true
      if (this.currentCommunity && this.currentCommunity.id) {
        // console.log("currentCommunity", this.currentCommunity.id);
        firstValueFrom(this.db.get('/web/bootcamps/', {communityid: this.currentCommunity.id}).pipe(debounceTime(1000)))
          .then((bootcamps:any) => {
            console.log("bootcamps1", bootcamps);
            this.bootcamps = bootcamps;
            this.showSpinner = false;
          })
      } else {
        firstValueFrom(this.db.get(`/web/bootcamps`).pipe(debounceTime(1000)))
          .then((bootcamps:any) => {
            // console.log("bootcamps2", bootcamps);
            this.bootcamps = bootcamps;
            this.showSpinner = false;
          })
      }
    }

    // loadBootcamps() {
    //   if (!this.bootcamps) {
    //     this.bootcamps$ = this.bc.getBootcamps();
    //   } else {
    //     this.bootcamps$ = of (this.bootcamps);
    //   }
    //   if (this.bootcampdeliveries) this.bootcampdeliveries.unsubscribe();
    //   this.bootcampdeliveries = 
    //     this.bootcamps$.pipe(
    //       take(1),
    //       switchMap(bcs => {
    //         this.bootcamps = bcs;
    //         if (this.community && this.community.id) {
    //           return this.db.docWithType$<Community>('community/' + this.community.id)
    //           .pipe(
    //             switchMap((community) => {
    //               let queries = [];
      
    //               if (community.type === "online-regional") {
    //                 queries = bcs.map(bootcamp => (ref => ref
    //                   .where('community.id', "==", this.community.id)
    //                   .where('startdate', ">=", moment().utc().toDate())
    //                   .where('display', '==', true)
    //                   .where('bootcamp.id', '==',  bootcamp.id)
    //                   .orderBy('startdate')
    //                   .limit(50)
    //                 ))
    //               } else {
    //                 queries = bcs.map(bootcamp => (ref => ref
    //                   .where('community.id', "==", this.community.id)
    //                   .where('startdate', ">=", moment().utc().toDate())
    //                   .where('display', '==', true)
    //                   .where('bootcamp.id', '==',  bootcamp.id)
    //                   .orderBy('startdate')
    //                   .limit(6)
    //                 ))
    //               }
    //               return combineLatest(queries.map(query => {
    //                 return this.db.colWithTypes$('bootcampdelivery', query)
    //                   .pipe(
    //                     switchMap(bootcampdeliveries => combineLatest(bootcampdeliveries.map(bc => this.bc.combineBootcamps(bc)))),
    //                     map(bootcamps => {
    //                       const red0bootcamps = bootcamps
    //                         .reduce((acc, cur)=> {
    //                           if (!acc[moment(cur.startdate.toDate()).format("YYYYMMDD") + cur.bootcamp.id]) acc[moment(cur.startdate.toDate()).format("YYYYMMDD") + cur.bootcamp.id] = [];
    //                           acc[moment(cur.startdate.toDate()).format("YYYYMMDD") + cur.bootcamp.id].push(cur);
    //                           return acc;
    //                         }, {})
    //                       return Object.keys(red0bootcamps).map((day, index) => {
    //                           if (red0bootcamps[day].length <= 2) return red0bootcamps[day];
    //                           else if (index === 0){
    //                             return [...red0bootcamps[day].filter(bc => bc.spotsleft <= 0).slice(0,1),  ...red0bootcamps[day].filter(bc => bc.spotsleft > 0).slice(0, 1)]
    //                           } else {
    //                             return red0bootcamps[day].filter(bc => bc.spotsleft > 0).slice(0, 1)
    //                           }
    //                         })
    //                         .reduce((acc, cur) => [...acc, ...cur], [])
    //                         .sort(this.bc.bootcampDateSort)
    //                     })
    //                   )
    //               }));
    //             }),
    //             debounceTime(200)
    //           )
    //         } else {
    //           return of ([])
    //         }

    //       })  
    //     ).subscribe(bootcampdeliveries => {
    //       // console.log("bootcampdeliveries", bootcampdeliveries);
    //       const maxBootcamps = Math.round((bootcampdeliveries.reduce((acc, cur) => acc + cur.length, 0) / bootcampdeliveries.length) - 0.01);
    //       // if (maxBootcamps < 3) maxBootcamps = 3;
    //       // console.log("maxBootcamps", maxBootcamps);
    //       bootcampdeliveries.forEach(bds => {
    //         const bdIndex = this.bootcamps.findIndex(bd => bds.some(bdsd => bdsd.bootcamp.id === bd.id));
    //         if (bdIndex !== -1) {
    //           this.bootcamps[bdIndex]["bootcampdeliveries"] = bds.slice(0, maxBootcamps);
    //         }
    //       })
    //       // console.log("this.bootcamps", this.bootcamps);
    //     })
    // }
}
